import script from "./KpiDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiDashboard.vue?vue&type=script&setup=true&lang=js"

import "./KpiDashboard.vue?vue&type=style&index=0&id=bc23ea40&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc23ea40"]])

export default __exports__